import React, { ReactNode, FC } from 'react'
import { Flex } from '@chakra-ui/react'

interface CardFrameProps {
  children: ReactNode;
  [x: string]: unknown;
}

const CardFrame: FC<CardFrameProps> = ({ children, ...rest }) => (
  <Flex
    border='1px solid'
    borderColor='secondary.60'
    borderRadius='12px'
    bg='white'
    justifyContent='space-between'
    {...rest}
  >
    {children}
  </Flex>
)

export default CardFrame
